<template>
  <ag-grid-vue
    :class="{ 'ag-theme-balham-dark' : isDark, 'ag-theme-balham' : !isDark }"
    :style="styleHeight"
    :columnDefs="columnDefs.value"
    :rowData="rowData.value"
    :defaultColDef="defaultColDef"
    rowSelection="single"
    suppressRowClickSelection="false"
    animateRows="true"
    @grid-ready="onGridReady"
    @selection-changed="onSelectionChanged"
  >
  </ag-grid-vue>
 
 </template>
 
 <script setup>
 
 import { useConnectionStore } from '@/stores/connectionStore';
 import { t } from '@/composables/translateText.js'
 import { AgGridVue } from "ag-grid-vue3";  // the AG Grid Vue Component
 import { reactive, onMounted, ref } from "vue";
 
 import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
 import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
 import "ag-grid-community/styles/ag-theme-balham.css"; // Optional theme CSS
 
 import { watch } from 'vue'
 import { computed } from "@vue/reactivity"
 
 const gridApi = ref(null); // Optional - for accessing Grid's API
 
 const emit = defineEmits(['game-click'])
 
 const props = defineProps({
   gameList : {
       type : Array,
       default : []
   },
   gameListTrigger : {
       type : Number,
       default : 0
   },
  styleHeight : {
    type : String,
    default :  "style= 'height: 300px'" 
  }
   
 })
 
 const connectionStore = useConnectionStore()
 const isDark = ref(connectionStore.getDarkmode != "light")
 
 // Obtain API from grid's onGridReady event
 const onGridReady = (params) => {
   gridApi.value = params.api;
 };
 
 const rowData = reactive({}); // Set rowData to Array of Objects, one Object per Row
 
 // Each Column Definition results in one Column.
 const columnDefs = ref({
   value: [
   
        { field: "white" , headerName: t("White") , resizable: true},
        { field: "black" , headerName: t("Black") ,resizable: true},
        { field: "date" , headerName: t("Date") , type: 'numericColumn', width: 100, maxWidth: 100},
        { field: "result", headerName: t("Result") ,width: 80, maxWidth: 80},
        { field: "wrating" , headerName: t("W-Rating"), type: 'numericColumn', filter: 'agNumberColumnFilter', width: 100, maxWidth: 100},
        { field: "brating" , headerName: t("B-Rating"),type: 'numericColumn', filter: 'agNumberColumnFilter', 
               width: 100, maxWidth: 100}
  
   ],
 });
 
 // DefaultColDef sets props common to all Columns
 const defaultColDef = {
   sortable: true,
   filter: true,
   flex: 1
 };
 
 const styleHeight = computed({
    get() {
      return props.styleHeight
    }
  })
  
 const games = computed({
     get() {
       return props.gameList
     }
   })
 
 const gameListTrigger = computed({
     get() {
       return props.gameListTrigger
     }
   })
 
 watch(gameListTrigger, (newVal,oldVal) => {

   rowData.value = games
   gridApi.value.refreshCells()
  })
 
 onMounted(() => {
   })
 
 function onSelectionChanged() {
   //console.log("GAME ROW selected")
   const selectedRows = gridApi.value.getSelectedRows();
   if (selectedRows.length > 0) {
     //console.log("selected info ",selectedRows[0])
     emit("game-click",selectedRows[0].id,selectedRows[0].white,selectedRows[0].black)
   }
}
 </script>
 
 <style scoped>
 
 </style>